import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=2b2ccc04&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=js&"
export * from "./Report.vue?vue&type=script&lang=js&"
import style0 from "./Report.vue?vue&type=style&index=0&id=2b2ccc04&scoped=true&lang=scss&"
import style1 from "./Report.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ccc04",
  null
  
)

export default component.exports